import { render, staticRenderFns } from "./WIcon.vue?vue&type=template&id=6cbd2a22&scoped=true&"
import script from "./WIcon.vue?vue&type=script&lang=ts&"
export * from "./WIcon.vue?vue&type=script&lang=ts&"
import style0 from "./WIcon.vue?vue&type=style&index=0&id=6cbd2a22&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cbd2a22",
  null
  
)

export default component.exports